// extracted by mini-css-extract-plugin
export var container = "_ui-0";
export var table = "_ui-2";
export var tableWrapper = "_ui-1";